/* eslint-disable eqeqeq */
const mykey = 'news_usercenterUI'
import Store from '@/store'
const members = {
  usercenterUI: null,

  getUser(callback, unuser) {
    this.rendy((usercenterUI) => {
      usercenterUI.getUser({
        show: 1 // 填写则显示vip相关字段
        // forceUpdate:true // 值为真则不管当前是否有用户信息都重新请求
      })
        .then(function(user) {
          callback(user)
        })
        .catch(function() {
          callback && callback({})
        })
    })
  },
  logout() {
    this.rendy((usercenterUI) => {
      usercenterUI.on('logout')
    })
  },
  loadJs(url, callback, dom) {
    var script = document.createElement('script')
    script.type = 'text/javascript'
    if (typeof callback !== 'undefined') {
      if (script.readyState) {
        script.onreadystatechange = function() {
          if (script.readyState == 'loaded' || script.readyState == 'complete') {
            script.onreadystatechange = null
            callback()
          }
        }
      } else {
        script.onload = function() {
          callback()
        }
      }
    }
    script.src = url;
    (dom || document.body).appendChild(script)
  },
  rendy(callback) {
    if (window[mykey]) {
      callback(window[mykey])
    } else {
      this.loadJs('https://cdn.jin10.com/plugins/login/v2.3/index.js', function() {
        // eslint-disable-next-line no-undef
        window[mykey] = new Jin10Login({
          showVIP: 0,
          isEmbed: !1,
          clickOut: !0,
          isLoginPage: !1,
          isDark: !1,
          showJobRules: true,
          loginCallback: function(n) {
            if (window.location.href.includes('list/info')) {
              const curr = window.location.href.replace('list/info', 'list/resume')
              window.location.href = curr
              Store.dispatch('user/GET_USER')
              Store.dispatch('resume/GET_DRAFT')
              window[mykey].close()
            } else {
              window.location.reload()
            }
          }
        })
        callback(window[mykey])
      })
    }
  },
  showLogin() {
    this.rendy((usercenterUI) => {
      usercenterUI.on('login')
    })
  },
  showRegister() {
    this.rendy((usercenterUI) => {
      usercenterUI.on('register')
    })
  }
}

export default members
